<template>
  <div class="btn-group">
    <bar-card :isBgColor="false">
      <div class="left-btn-group">
        <el-button
          v-for="item in leftGroups"
          :key="item.label"
          :type="getDisabled(item)?'default':'primary'"
          :plain="'plain' in item ? item.plain :false"
          :disabled="getDisabled(item)"
          @click="item.event"
        >
          {{item.label}}
        </el-button>
      </div>
      <div class="right-btn-group">
        <div style="margin:0 20px;display:inline-block;">
          <slot name="rightBtnPrefix"></slot>
        </div>

        <el-button
          class="right-btn"
          v-for="item in rightGroups"
          :key="item.label"
          :loading="item.loading"
          :type="item.type||'primary'"
          @click="item.event(item)"
        >
          {{item.label}}
        </el-button>
      </div>
    </bar-card>
  </div>
</template>

<script>
import barCard from '@/components/customPageCard/barCard.vue'
export default {
  name: 'btn-group',
  components: {
    barCard,
  },
  props: {
    btnList: {
      type: Object,
    },
  },
  computed: {
    rightGroups() {
      if (this.btnList && this.btnList.rightGroups) {
        return this.btnList.rightGroups.filter((item) => item.showBtn !== false)
      }
      return []
    },
    leftGroups() {
      if (this.btnList && this.btnList.leftGroups) {
        return this.btnList.leftGroups.filter((item) => item.showBtn !== false)
      }
      return []
    },
  },
  methods: {
    getDisabled(item) {
      if (item.hasOwnProperty('disabled')) {
        if (typeof item.disabled == 'function') return item.disabled(item)
        return item.disabled
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-group {
  background-color: #fff;
  .right-btn {
    margin-left: 10px;
  }
}
</style>